module.exports = __webpack_public_path__ + "media/application/images/icons/topics-partnerships-pebble-dark-green-rgb-62a7d4a5b22bd4e97853d39f07f4ab76.svg";